export default __webpack_public_path__ + "static/media/aprTypeChangeIcon.91b0d128.svg";